import { createContext } from "react";

export const defaultValue = {
	isModal: false,
	closeTo: null,
};

const ModalRoutingContext = createContext(defaultValue);

export default ModalRoutingContext;